import React from 'react';
import { motion } from 'framer-motion';
import { RegistrationForm } from './RegistrationForm';
export function RegistrationSection() {
  return <section id="registro" className="w-full bg-brand-dark py-24 relative overflow-hidden" data-id="element-119">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-brand-pink opacity-10 blur-[100px] rounded-full pointer-events-none" data-id="element-120"></div>

      <div className="max-w-3xl mx-auto px-6 relative z-10" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-brand-gray border border-white/10 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-122">
          <div className="text-center mb-10" data-id="element-123">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-124">
              Asegura tu lugar gratis
            </h2>
            <p className="text-brand-pink font-medium" data-id="element-125">
              Válido antes del 21 de julio
            </p>
          </div>

          <RegistrationForm idPrefix="registro" data-id="element-126" />
        </motion.div>
      </div>
    </section>;
}